// function used for hashing email for tracking purpose
// it is a replicate from the same function used by subscription team
export const hashValue = async (value: string): Promise<string | undefined> => {
  if (!value) {
    return value
  }

  const valueToHash = value.toString().toLowerCase()
  const buffer = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(valueToHash)
  )
  const hashArray = Array.from(new Uint8Array(buffer))
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
}
